<template>
  <div>
    <template v-for="businessLocation in businessLocations">
      <b-row :key="businessLocation.business_location_code">
        <b-col>
          <esg-base-dashboard-card :title="`${corporation.name} > ${businessLocation.name} 월별 온실가스 배출량`">
            <monthly-emission-by-scope-for-biz-loc :corporation="corporation"
                                                   :business-location="businessLocation"/>
          </esg-base-dashboard-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import EsgBaseDashboardCard from "@/components/esg/base/EsgBaseDashboardCard.vue";
import MonthlyEmissionByScopeForBizLoc from "../charts2/BizLocMonthlyEmissionByScope.vue";

export default {
  name: "MonthlyEmissionByScopeForAllBizLocs",
  props: {
    corporation: {
      type: Object,
      required: true,
    }
  },
  components: { MonthlyEmissionByScopeForBizLoc, EsgBaseDashboardCard },
  data() {
    return {
      businessLocations: []
    }
  },
  watch: {
    corporation: {
      deep: true,
      immediate: true,
      handler(newCorp, oldCorp) {
        if (!oldCorp || newCorp.code !== oldCorp.code) {
          this.fetchBusinessLocations();
        }
      }
    }
  },
  methods: {
    async fetchBusinessLocations() {
      if (!this.corporation || !this.corporation.code)
        return;

      try {
        let response = await axios.get('esg/lca/business-location', {
          headers: { Authorization: accessToken() },
          params: {
            filters: [
              {
                name: 'esg_base_corporation.tenant_id',
                value: this.tenantId(),
                operation: 'EQUAL'
              },
              {
                name: 'esg_base_corporation.code',
                value: this.corporation.code,
                operation: 'EQUAL'
              }
            ]
          }
        });

        this.businessLocations = response.data.list;
      } catch (error) {
        await this.showError(error);
      }
    },
  }
}
</script>

<style scoped>

</style>